import { render, staticRenderFns } from "./videoIframe.vue?vue&type=template&id=20b9c1df&"
import script from "./videoIframe.vue?vue&type=script&lang=js&"
export * from "./videoIframe.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('20b9c1df')) {
      api.createRecord('20b9c1df', component.options)
    } else {
      api.reload('20b9c1df', component.options)
    }
    module.hot.accept("./videoIframe.vue?vue&type=template&id=20b9c1df&", function () {
      api.rerender('20b9c1df', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2J0FB2jWlGFqV/JS/videoIframe.vue"
export default component.exports